import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const PoftfolioImages = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper
                smallPaddings={true}
                isMargin={false}
                caseName="tech-leader-portfolio-images"
            >
                <div className="tech-leader-portfolio-images__wrapper">
                    <div className="tech-leader-portfolio-images__big-img">
                        <CommonSmallText className="tech-leader-portfolio-images__title-wrapper">
                            С&nbsp;проектной командой клиента мы&nbsp;проработали 5&nbsp;разных
                            представлений сетки и&nbsp;в&nbsp;итоге остановились на&nbsp;одной:
                        </CommonSmallText>
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={50}
                            animateOnce={true}
                            duration={1}
                        >
                            <img
                                src="/images/pic/tech-leaders/tech-leader-portfolio-img1.png"
                                alt=""
                                loading="lazy"
                            />
                        </ScrollAnimation>
                    </div>
                    <div className="tech-leader-portfolio-images__small-imgs-wrapper">
                        <CommonSmallText className="tech-leader-portfolio-images__title-wrapper tech-leader-portfolio-images__title-wrapper--variants">
                            Варианты{' '}
                        </CommonSmallText>
                        <div className="tech-leader-portfolio-images__small-imgs">
                            <div className="tech-leader-portfolio-images__left-inner">
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <img
                                        src="/images/pic/tech-leaders/tech-leader-portfolio-img2.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </ScrollAnimation>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <img
                                        src="/images/pic/tech-leaders/tech-leader-portfolio-img3.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </ScrollAnimation>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <img
                                        src="/images/pic/tech-leaders/tech-leader-portfolio-img4.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </ScrollAnimation>
                            </div>
                            <div className="tech-leader-portfolio-images__right-inner">
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <img
                                        src="/images/pic/tech-leaders/tech-leader-portfolio-img5.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </ScrollAnimation>
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                >
                                    <img
                                        src="/images/pic/tech-leaders/tech-leader-portfolio-img6.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default PoftfolioImages;
